import { useEffect, useRef } from 'react'

import style from './confetti-explosion.module.scss'
interface ConfettiExplosionProps {
  trigger: boolean
  onComplete?: () => void
}

function getRandomIntInclusive(min: number, max: number) {
  const minCeiled = Math.ceil(min)
  const maxFloored = Math.floor(max)
  return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled)
}

function getRandomColor() {
  const colors = [
    'rgba(245, 236, 168, 0.91)',
    'rgba(245, 236, 168, 0.9)',
    'rgba(245, 236, 168, 0.64)',
    'rgba(245, 236, 168, 0.69)',
    'rgba(245, 236, 168, 0.65)',
  ]
  return colors[getRandomIntInclusive(0, colors.length - 1)]
}

function getRandomCrownColor() {
  const r = getRandomIntInclusive(236, 242)
  const g = getRandomIntInclusive(196, 241)
  const b = getRandomIntInclusive(195, 242)
  return `rgb(${r}, ${g}, ${b})`
}

export default function ConfettiExplosionCSS({ trigger, onComplete }: ConfettiExplosionProps) {
  const originRef = useRef<HTMLDivElement>(null)
  const hasTriggeredRef = useRef(false)

  function generateParticle(origin: HTMLDivElement) {
    const particle = document.createElement('span')
    particle.classList.add(style.confettiParticle)

    const angle = getRandomIntInclusive(0, 360)

    const distance = getRandomIntInclusive(80, 280)

    const scale = getRandomIntInclusive(20, 100) / 50

    const lifetime = getRandomIntInclusive(400, 1200)

    const particleType = getRandomIntInclusive(1, 100)
    let particleColor = getRandomColor()
    let particleSize = getRandomIntInclusive(4, 8)

    if (particleType <= 20) {
      particleColor = getRandomCrownColor()
      particleSize = getRandomIntInclusive(6, 11)
    }

    // Apply styles
    particle.style.cssText = `
      --particle-size: ${particleSize}px;
      --particle-color: ${particleColor};
      --angle: ${angle}deg;
      --distance: ${distance}px;
      --scale: ${scale};
      --lifetime: ${lifetime}ms;
    `

    origin.append(particle)

    particle.addEventListener('animationend', () => {
      if (origin.contains(particle)) {
        particle.remove()
      }
    })
  }

  function generateGlowField(origin: HTMLDivElement) {
    const glow = document.createElement('div')
    glow.classList.add(style.confettiGlow)

    const maxRadius = Math.min(window.innerWidth, window.innerHeight) * 0.4

    glow.style.cssText = `--radius: ${maxRadius}px;`

    origin.append(glow)

    setTimeout(() => {
      if (origin.contains(glow)) {
        glow.remove()
      }
    }, 1000)
  }

  useEffect(() => {
    if (trigger && !hasTriggeredRef.current && originRef.current) {
      hasTriggeredRef.current = true
      const origin = originRef.current

      const particleCount = getRandomIntInclusive(60, 80)

      generateGlowField(origin)

      for (let i = 0; i < particleCount; i++) {
        generateParticle(origin)
      }

      if (onComplete) {
        setTimeout(() => {
          onComplete()
        }, 1500)
      }
    }
  }, [trigger, onComplete])

  useEffect(() => {
    if (!trigger) {
      hasTriggeredRef.current = false
    }
  }, [trigger])

  return <div ref={originRef} className={style.confettiCSS} />
}
